export enum TipoIdentificacion {
  CED_EXTRANJERIA = 'E',
  TARJ_IDENTIDAD = 'T',
  DIPLOMATICO = 'D',
  NIT = 'A',
  CEDULA = 'C',
  PASAPORTE = 'P',
}
